/* Nutrition Advice — small progressive enhancements for the NA sections.
   Every section still renders useful content without this file. */
(function () {
  'use strict';

  var ready = function (fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  /* ---------- hero video: muted autoplay + "Play with sound" ---------- */
  function initHeroVideo(root) {
    root.querySelectorAll('[data-na-sound]').forEach(function (btn) {
      if (btn.dataset.naReady) return;
      btn.dataset.naReady = '1';
      var frame = btn.closest('.na-hero__frame');
      var video = frame && frame.querySelector('[data-na-hero-video] video');
      if (!video) { btn.hidden = true; return; }
      video.muted = true;
      video.setAttribute('playsinline', '');
      video.removeAttribute('controls');
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
      btn.addEventListener('click', function () {
        var unmute = video.muted;
        video.muted = !unmute;
        if (unmute) {
          try { video.currentTime = 0; } catch (e) {}
          var q = video.play();
          if (q && q.catch) q.catch(function () {});
        }
        btn.setAttribute('aria-pressed', unmute ? 'true' : 'false');
      });
    });
  }

  /* ---------- subject intro videos: one plays at a time ---------- */
  function initSubjectVideos(root) {
    root.querySelectorAll('[data-na-subject-video]').forEach(function (wrap) {
      if (wrap.dataset.naReady) return;
      wrap.dataset.naReady = '1';
      var video = wrap.querySelector('video');
      var btn = wrap.querySelector('[data-na-play]');
      if (!video || !btn) return;
      video.removeAttribute('controls');
      video.setAttribute('playsinline', '');
      video.preload = 'metadata';
      var sync = function () { btn.setAttribute('aria-pressed', video.paused ? 'false' : 'true'); wrap.classList.toggle('is-playing', !video.paused); };
      btn.addEventListener('click', function () {
        if (video.paused) {
          document.querySelectorAll('[data-na-subject-video] video').forEach(function (v) { if (v !== video) v.pause(); });
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        } else {
          video.pause();
        }
      });
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('ended', function () { video.currentTime = 0; sync(); });
    });
  }

  /* ---------- book shelf / library filter ---------- */
  function initBooks(root) {
    root.querySelectorAll('[data-na-books]').forEach(function (section) {
      if (section.dataset.naReady) return;
      section.dataset.naReady = '1';
      var grid = section.querySelector('[data-na-books-limit]');
      if (!grid) return;
      var limit = parseInt(grid.getAttribute('data-na-books-limit'), 10) || 999;
      var books = Array.prototype.slice.call(grid.querySelectorAll('.na-book'));
      var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-na-topic]'));
      var search = section.querySelector('[data-na-books-search]');
      var count = section.querySelector('[data-na-books-count]');
      var empty = section.querySelector('[data-na-books-empty]');
      var reset = section.querySelector('[data-na-books-reset]');
      var topic = 'all';

      function apply() {
        var q = search ? search.value.trim().toLowerCase() : '';
        var shown = 0;
        books.forEach(function (b) {
          var okTopic = topic === 'all' || b.getAttribute('data-na-cat') === topic;
          var okText = !q || (b.getAttribute('data-na-text') || '').indexOf(q) !== -1;
          var show = okTopic && okText && shown < limit;
          b.hidden = !show;
          if (show) shown++;
        });
        if (count) count.textContent = shown;
        if (empty) empty.hidden = shown !== 0;
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          topic = tab.getAttribute('data-na-topic');
          tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
          apply();
        });
      });
      if (search) search.addEventListener('input', apply);
      var hashTopic = (window.location.hash || '').replace('#', '');
      if (hashTopic) {
        var hashTab = tabs.filter(function (t) { return t.getAttribute('data-na-topic') === hashTopic; })[0];
        if (hashTab) {
          topic = hashTopic;
          tabs.forEach(function (t) { t.setAttribute('aria-selected', t === hashTab ? 'true' : 'false'); });
          setTimeout(function () { section.scrollIntoView({ block: 'start' }); }, 60);
        }
      }
      if (reset) reset.addEventListener('click', function () {
        topic = 'all';
        if (search) search.value = '';
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-na-topic') === 'all' ? 'true' : 'false'); });
        apply();
      });
      apply();
    });
  }

  /* ---------- nutrition snapshot calculator (Mifflin-St Jeor, women) ---------- */
  function initCalc(root) {
    root.querySelectorAll('[data-na-calc]').forEach(function (calc) {
      if (calc.dataset.naReady) return;
      calc.dataset.naReady = '1';
      var goal = 'maintain';
      var goals = calc.querySelectorAll('[data-na-goal]');
      var results = calc.querySelector('[data-na-calc-results]');
      var num = function (sel) { var el = calc.querySelector(sel); return el ? parseFloat(el.value) : NaN; };
      var out = function (sel, v) { var el = calc.querySelector(sel); if (el) el.textContent = v; };

      goals.forEach(function (g) {
        g.addEventListener('click', function () {
          goal = g.getAttribute('data-na-goal');
          goals.forEach(function (x) { x.setAttribute('aria-pressed', x === g ? 'true' : 'false'); });
          if (results && !results.hidden) compute();
        });
      });

      function compute() {
        var age = num('[data-na-age]'), lb = num('[data-na-weight]'), inch = num('[data-na-height]'), act = num('[data-na-activity]');
        if (!(age > 0 && lb > 0 && inch > 0 && act > 0)) {
          out('[data-na-out-cal]', '–'); out('[data-na-out-protein]', '–'); out('[data-na-out-water]', '–');
          if (results) results.hidden = false;
          return;
        }
        var bmr = 10 * (lb * 0.453592) + 6.25 * (inch * 2.54) - 5 * age - 161;
        var maintenance = Math.round(bmr * act);
        var cal = goal === 'lose' ? maintenance - 300 : goal === 'gain' ? maintenance + 250 : maintenance;
        out('[data-na-out-cal]', cal.toLocaleString());
        out('[data-na-out-protein]', Math.round(lb * 0.7) + '–' + Math.round(lb) + 'g');
        out('[data-na-out-water]', Math.round(lb * 0.5) + ' oz');
        if (results) results.hidden = false;
      }

      var go = calc.querySelector('[data-na-calc-go]');
      if (go) go.addEventListener('click', compute);
    });
  }

  /* ---------- start here route finder ---------- */
  function initQuiz(root) {
    root.querySelectorAll('[data-na-quiz]').forEach(function (quiz) {
      if (quiz.dataset.naReady) return;
      quiz.dataset.naReady = '1';
      var box = quiz.querySelector('[data-na-quiz-box]');
      var steps = Array.prototype.slice.call(quiz.querySelectorAll('[data-na-step]'));
      var results = Array.prototype.slice.call(quiz.querySelectorAll('[data-na-result]'));
      var back = quiz.querySelector('[data-na-quiz-back]');
      var answers = [];

      function show(i) {
        steps.forEach(function (s, n) { s.hidden = n !== i; });
        if (back) back.hidden = i === 0;
      }
      function choose(list) {
        var counts = {};
        list.forEach(function (a) { counts[a] = (counts[a] || 0) + 1; });
        return list.reduce(function (win, a) { return counts[a] > (counts[win] || 0) ? a : win; }, list[0]);
      }
      function finish() {
        var key = choose(answers);
        if (box) box.hidden = true;
        results.forEach(function (r) {
          var match = r.getAttribute('data-na-result') === key;
          r.hidden = !match;
          if (match) { try { r.focus({ preventScroll: true }); } catch (e) { r.focus(); } r.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        });
      }
      function restart() {
        answers = [];
        results.forEach(function (r) { r.hidden = true; });
        if (box) box.hidden = false;
        show(0);
      }

      quiz.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-na-answer]');
        if (opt && quiz.contains(opt)) {
          answers.push(opt.getAttribute('data-na-answer'));
          if (answers.length >= steps.length) finish();
          else show(answers.length);
          return;
        }
        if (e.target.closest('[data-na-quiz-back]')) {
          answers.pop();
          show(answers.length);
          return;
        }
        if (e.target.closest('[data-na-quiz-restart]')) restart();
      });
      if (!steps.length && box) box.hidden = true;
      else show(0);
    });
  }

  /* ---------- education room: topic lanes + AskSonya hand-off ---------- */
  function initAsk(root) {
    root.querySelectorAll('[data-na-ask]').forEach(function (ask) {
      if (ask.dataset.naReady) return;
      ask.dataset.naReady = '1';
      var form = ask.querySelector('[data-na-ask-form]');
      var input = ask.querySelector('[data-na-ask-input]');
      var log = ask.querySelector('[data-na-ask-log]');
      var lanes = Array.prototype.slice.call(ask.querySelectorAll('[data-na-lane]'));
      var base = (ask.getAttribute('data-na-ask-url') || 'https://asksonya.ai/').split('#')[0];
      var status = ask.getAttribute('data-na-ask-status') || 'Opening AskSonya.ai in a new tab.';
      var linkLabel = ask.getAttribute('data-na-ask-link-label') || 'Open AskSonya.ai';
      if (!form || !input) return;

      function bubble(kind, text, url) {
        if (!log) return;
        var el = document.createElement('div');
        el.className = 'na-ask__msg na-ask__msg--' + kind;
        var p = document.createElement('p');
        p.textContent = text;
        el.appendChild(p);
        if (url) {
          var lp = document.createElement('p');
          var a = document.createElement('a');
          a.href = url; a.target = '_blank'; a.rel = 'noopener';
          a.textContent = linkLabel + ' \u2197';
          lp.appendChild(a);
          el.appendChild(lp);
        }
        log.appendChild(el);
        var extra = log.querySelectorAll('.na-ask__msg');
        if (extra.length > 7) log.removeChild(extra[1]);
        el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }

      lanes.forEach(function (lane) {
        lane.addEventListener('click', function () {
          input.value = lane.getAttribute('data-na-lane') || '';
          lanes.forEach(function (l) { l.setAttribute('aria-pressed', l === lane ? 'true' : 'false'); });
          input.focus();
          try { input.setSelectionRange(input.value.length, input.value.length); } catch (e) {}
        });
      });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var q = input.value.trim();
        if (!q) { input.focus(); return; }
        // The question goes in the URL fragment, which browsers never send to a server.
        var url = base + '#ask=' + encodeURIComponent(q);
        try { if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(q).catch(function () {}); } catch (err) {}
        var a = document.createElement('a');
        a.href = url; a.target = '_blank'; a.rel = 'noopener';
        document.body.appendChild(a); a.click(); a.remove();
        bubble('you', q);
        bubble('bot', status, url);
        input.value = '';
        lanes.forEach(function (l) { l.setAttribute('aria-pressed', 'false'); });
      });
    });
  }

  function initAll(root) {
    root = root || document;
    initHeroVideo(root);
    initSubjectVideos(root);
    initBooks(root);
    initCalc(root);
    initQuiz(root);
    initAsk(root);
  }

  ready(function () { initAll(document); });
  // Re-run when sections are edited in the theme editor
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
